import React, { useCallback } from 'react'

import { bool, func, string } from 'prop-types'

import { getFeatureFilter } from 'Pods/SearchPage/Shared/Tracking/constants'
import { useTrackFilterSelect } from 'Pods/SearchPage/Shared/Tracking/FilterTracking'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'

import FilterChip from '../../../Shared/FilterChip/FilterChip'

// Extracted so each chip subscribes only to the slice it cares about - sibling
// toggles don't trigger this row's re-render.
function PrintAttributesChip({
  chipKey, select, onChange, isHiddenAtMd = false, isHiddenAtSm = false,
}) {
  const translate = useTranslate()

  const isChecked = useSearchPageStore(select)
  const trackFilterSelect = useTrackFilterSelect()

  const handleChange = useCallback((nextChecked) => {
    if (nextChecked) {
      const { name, value } = getFeatureFilter(chipKey)
      trackFilterSelect(name, value)
    }
    onChange(nextChecked)
  }, [chipKey, onChange, trackFilterSelect])

  return (
    <FilterChip
      id={`print-attr-${chipKey}`}
      label={translate(`search_page.filters.print_attributes.${chipKey}`)}
      isChecked={isChecked}
      onChange={handleChange}
      isHiddenAtMd={isHiddenAtMd}
      isHiddenAtSm={isHiddenAtSm}
    />
  )
}

PrintAttributesChip.propTypes = {
  chipKey: string.isRequired,
  select: func.isRequired,
  onChange: func.isRequired,
  isHiddenAtMd: bool,
  isHiddenAtSm: bool,
}

export default PrintAttributesChip
